jQuery(document).ready(function($) {
  $("#accordion").accordion({
    collapsible: true,
    active: false
  });


        function convertSelectToButtons() {
          const select = document.querySelector('.product__variants-select select');
          const buttonContainer = document.createElement('div');
          buttonContainer.className = 'button-select';
          
          Array.from(select.options).forEach(option => {
              const button = document.createElement('div');
              button.className = 'button-option';
              button.textContent = option.text;
              button.dataset.value = option.value;
              
              if (option.selected) {
                  button.classList.add('selected');
              }
              
              button.addEventListener('click', function() {
                  buttonContainer.querySelectorAll('.button-option').forEach(btn => btn.classList.remove('selected'));
                  this.classList.add('selected');
                  select.value = this.dataset.value;
                  
                  // Dispatch change event
                  const event = new Event('change', { bubbles: true });
                  select.dispatchEvent(event);
              });
              
              buttonContainer.appendChild(button);
          });
          
          select.parentNode.insertBefore(buttonContainer, select.nextSibling);
          select.style.display = 'none';
      }

      // Convert the select to buttons
      //convertSelectToButtons();

  
});

jQuery(document).ready(function($) {
  const urlParams = new URLSearchParams(window.location.search);
  var currentvariant = urlParams.get('variant') || ''; 
  if(currentvariant !== ''){
     $('.product-variants input#radio_' + currentvariant).prop('checked', true).change();
  }
	$('.product-variants li').removeClass('active');
	$('.product-variants input:checked').parent('li').addClass('active');
	$( ".template-product #accordion" ).accordion({header: "headeracordion",collapsible: true, active: 2});
    var varprice = $(".variant_list.active input").attr("data-price");
    var vartitle = $(".variant_list.active input").attr("data-title");
    $(".select_radio_data").html(vartitle+" for "+varprice);
    var rc_compare = $(".compare_price_rc").html(varprice);
	$('.product-variants li input').click(function(event) {
		$('.product-variants li').removeClass('active');
		$('.product-variants input:checked').parent('li').addClass('active');
		var quantity = $('.quantity-selector__wrapper .QuantityInput').val();
		var current_price = $(this).siblings('label').find('.bold-blue').text().replace('$','');
		var current_price_f = current_price.replace('.','');
		$('.add-to-cart__wrapper .buttonPrice .money').text('$'+ (current_price * quantity).toFixed(2));
		$('.add-to-cart__wrapper .buttonPrice').attr('data-item-price',current_price_f);
        var varprice = $(".variant_list.active input").attr("data-price");
        var vartitle = $(".variant_list.active input").attr("data-title");
        $(".select_radio_data").html(vartitle+" for "+varprice);
        var rc_compare = $(".compare_price_rc").html(varprice);
        var rc_comparenew = $(".compare_price_rc").html();
        $(".btn_compare_price").html(rc_comparenew);
	});
    $('.rc_option__one-time input').click(function(event) {
      $(".btn_compare_price").hide();
      $(".btn_compare_price").html("");
    });
    $('.rc_option__recurring input').click(function(event) {
      var rc_compare = $(".compare_price_rc").html();
      $(".btn_compare_price").show();
      $(".btn_compare_price").html(rc_compare);
    });  
	$('#shopify-section-1568401969279').append('<a href="#" class="scroll-down" address="true">.</a>');
	$('.scroll-down').click (function() {
		$('html, body').animate({scrollTop: $('#shopify-section-1549316643918').offset().top }, 'slow');
		return false;
	});
  	$('.header-icons .phone').click(function(event) {
		$('.header-icons .phonePop').toggle();
	});
});


 jQuery(document).ready(function($) {
   $('.featured-in-logos .items').slick({
    infinite:true,
    centerMode: false,
    slidesToShow:5,
    adaptiveHeight: true,
    slidesToScroll:1,
        arrows: true,
    autoplay: true,
  autoplaySpeed: 2000,
     prevArrow: '<button aria-label="Prev" type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button aria-label="Next" type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
  }); 
});

	jQuery(document).ready(function($) {
		$('.slideshow-images').each(function() {
			$(this).find('.slideshow-image').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
              dots: true,
              autoplay: true,
              autoplaySpeed: 9000,
              prevArrow: '<button aria-label="Prev" type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
              nextArrow: '<button aria-label="Next" type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
			});
		});
	});




jQuery(document).ready(function($) {
			var settings = {
				"url": "https://gfjules.com/wp-json/wp/v2/recipes?_fields[]=title&_fields[]=link&_fields[]=featured_media&_fields[]=recipe_image_url&per_page=5&order=desc",
				"method": "GET",
				"timeout": 0,
			};
			$.ajax(settings).done(function (response) {
				var html_items ='';
				if (response) {
					for (var i = response.length - 1; i >= 0; i--) {
						html_items+='<div class="item">';
						html_items+='<a href="'+response[i].link+'"><img src="'+response[i].recipe_image_url+'" class="lazyload fade-in" width="500" height="400" alt="'+response[i].title.rendered+'"></a>';
						html_items+='<h2><a href="'+response[i].link+'">'+response[i].title.rendered+'</a></h2>';
						html_items+='</div>';
					}
				}
				$('.get_recipes_wp').html('<div class="items">'+html_items+'</div>');
				$('.get_recipes_wp .items').slick({
					autoplay:true,
					infinite:true,
					slidesToShow:3,
					slidesToScroll:1,
					arrows: true,
                  prevArrow: '<button aria-label="Prev" type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
                  nextArrow: '<button aria-label="Next" type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
					responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					]
				});
			});
		});
/*
	jQuery(document).ready(function($) {
			if ($('body').hasClass('template-product')) {
				var tag = $('.product__section-right h1.h2').text().replace('&', '');
				$('.template-product .product-related-video').append('<div class="related-recipes"><h2>see related recipes</h2><ul></ul></div>');
				var res = tag.replace(/\s+/g, "+").replace(/\++/g, "+");
				var url_recipes = 'https://gfjules.com/recipes?s='+res+'&post_type=recipes';
				$('.related-recipes').html('<a target="_blank" class="link-btn" href="'+url_recipes+'">See recipes using this mix</a>');
			}
	});
*/

		jQuery(document).ready(function($) {
          if ($('body').hasClass('template-product')) {
  $.getJSON( "https://www.googleapis.com/youtube/v3/channels?id=UCecQ2xQPVZUHoDOjL_bRgMg&key=AIzaSyBwi5wMCNBxBgHinbve38vNSL-vMyMbemQ&part=contentDetails", function( data ) {
      var playlist_id = data.items[0].contentDetails.relatedPlaylists.uploads;
      $.getJSON( "https://www.googleapis.com/youtube/v3/playlistItems?playlistId="+playlist_id+"&key=AIzaSyBwi5wMCNBxBgHinbve38vNSL-vMyMbemQ&part=snippet&maxResults=50", function( videos ) {
        $('.tumbails-video-product').html(' ');
        $('.list-tumbails-video-product').html(' ');
        
        $(videos.items).each(function(index, el) {
          $('.tumbails-video-product').append('<div class="item"> <img alt="video" class="thumbnail" src="'+el.snippet.thumbnails.medium.url+'" data-video-id="'+el.snippet.resourceId.videoId+'"><span class="video-title">'+el.snippet.title+'</span></div>');
          $('.list-tumbails-video-product').append('<div class="item"> <img alt="video" class="thumbnail" src="'+el.snippet.thumbnails.medium.url+'" data-video-id="'+el.snippet.resourceId.videoId+'"><span class="video-title">'+el.snippet.title+'</span></div>');
        });
        
        $('.tumbails-video-product').slick({
          infinite:false,
          slidesToShow:3,
          slidesToScroll:1,
          prevArrow: '<button aria-label="Prev" type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
          nextArrow: '<button aria-label="Next" type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          ]
        });
        

        var player,time_update_interval = 0;

        function onYouTubeIframeAPIReady() {
          player = new YT.Player('video-placeholder', {
            width: 600,
            height: 400,
            videoId: 'Cda5XCObfXc',
            playerVars: {
              rel: 0, 
              showinfo: 0, 
              ecver: 2,
              'origin':'https://shop.gfjules.com'
            }
          });
        }
        window.YT.ready(function() {
          player = new window.YT.Player("video-placeholder", {
            height: "400",
            width: "660",
            videoId: "Cda5XCObfXc",
            playerVars: {
              rel: 0, 
              showinfo: 0, 
              ecver: 2,
              'origin':'https://shop.gfjules.com'
            }
          });
        });
      
      $('.thumbnail').on('click', function () {
        var url = $(this).attr('data-video-id');
        var title = $(this).siblings('.video-title').text();
        player.cueVideoById(url);
        $('.popup-player').addClass('active');
        $('.popup-player .video-title').text(title);
        player.playVideo();
      });

      $('.video-title').on('click', function () {
        $(this).siblings('.thumbnail').click();
      });

      $('.close').on('click', function () {
        $('.popup-player').removeClass('active');
        player.pauseVideo();
      });
    });
    });
            }
});


jQuery(function($) {
    $('.dynamic-section-slider').each(function() {
        const $slider = $(this);
        const $sliderContent = $slider.find('.slider');
        let slidesToShow = parseInt($slider.attr('data-slidesToShow'));
		let slidesToScroll = parseInt($slider.attr('data-slidesToScroll'));
		let infinite = ( $slider.attr('data-infinite')=="true")?true:false;
		let arrows = ( $slider.attr('data-arrows')=="true")?true:false;
		let dots = ( $slider.attr('data-dots')=="true")?true:false;
		let autoplay = ( $slider.attr('data-autoplay')=="true")?true:false;
        if ($sliderContent.length) {
           $(this).find('.slider').slick({
    				slidesToShow:slidesToShow,
    				slidesToScroll:slidesToScroll,
    				infinite:infinite,
    				arrows:arrows,
    				dots:dots,
    				autoplay:autoplay,
    				prevArrow: '<button aria-label="Prev" type="button" class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
                    nextArrow: '<button aria-label="Next" type="button" class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    				responsive: [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        }
    },
    {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
    		});
        }
    });
});


jQuery(document).ready(function($) {
		var settings = {
			"url": "https://gfjules.com/wp-json/wp/v2/recipes?_fields[]=title&_fields[]=link&_fields[]=featured_media&_fields[]=recipe_image_url&per_page=8&order=desc",
			"method": "GET",
			"timeout": 0,
		};
		$.ajax(settings).done(function (response) {
			var html_items ='';
			if (response) {
				for (var i = response.length - 1; i >= 0; i--) {
					html_items+='<div class="item">';
					html_items+='<div class="content">';
					html_items+='<img src="'+response[i].recipe_image_url+'" class="lazyload fade-in" width="500" height="400" alt="'+response[i].title.rendered+'">';
					html_items+='<a href="'+response[i].link+'"><h2>'+response[i].title.rendered+'</h2></a>';
					html_items+='</div>';
					html_items+='</div>';
				}
			}
			$('.grid_recipes_wp').html('<div class="items">'+html_items+'</div>');
			setTimeout(function() {
				$('.grid_recipes_wp .items').masonry({
                itemSelector: '.item'
            });
			}, 1000);
		});
	});
jQuery(document).ready(function($) {
	$('.custom-variants-items input').click(function(event) {
		var current = $(this).val();
		$("select.custom-variable-select-options-all").val(current).change();
	});

});

jQuery(document).ready(function($) {
    $('.ingredient-see-more').click(function(event) {
        var container = $(this).closest('.custom-ingredients-content');
        if(container.hasClass('active')){
            container.removeClass('active');
            $(this).text('See More');
            var offsetTop = container.offset().top - 100;
            $('html, body').animate({
                scrollTop: offsetTop
            }, 500);
        } else {
            container.addClass('active');
            $(this).text('See Less');
        }
    });
});

/* Update main price + price subtitle (bags · price · cups) on variant radio change */
jQuery(document).ready(function($) {
  function gfUpdatePriceMeta() {
    var $input = $('.product-variants .variant_list input:checked');
    if (!$input.length) { $input = $('.product-variants .variant_list input').first(); }
    if (!$input.length) return;

    // price markup as rendered by the money filter (safe: read from element, not attribute)
    var priceHtml = $input.siblings('label').find('.bold-blue').html();

    if (priceHtml) {
      $('.product__price [data-regular-price]').html(priceHtml);
    }

    var $sub = $('[data-price-subtitle]');
    if (!$sub.length) return;

    if (priceHtml) {
      $sub.find('[data-subtitle-price]').html(priceHtml);
    }

    // values taken directly from variant metafields (no calculation)
    var cups = $input.attr('data-cups');
    var bags = $input.attr('data-bags');
    var hasCups = cups !== undefined && cups !== '';
    var hasBags = bags !== undefined && bags !== '';

    // both metafields are required
    if (!hasCups || !hasBags) {
      $sub.attr('hidden', 'hidden');
      return;
    }
    $sub.removeAttr('hidden');

    $sub.find('[data-subtitle-bags]').text(bags + (String(bags) === '1' ? ' bag' : ' bags'));
    $sub.find('[data-subtitle-cups]').html('≈ ' + cups + ' cups');
  }

  $(document).on('change', '.product-variants .variant_list input', gfUpdatePriceMeta);
  gfUpdatePriceMeta();
});

/* Order summary: "{qty} x {variant} · {option}" + subtotal, synced with ReCharge widget */
jQuery(document).ready(function($) {
  var widget = document.querySelector('recharge-subscription-widget');
  var sr = widget && widget.shadowRoot;
  var hasWidget = !!widget;

  var $summary = $('[data-order-summary]');
  var $sticky = $('[data-sticky-atc]');

  // Title injected inside the ReCharge widget's shadow DOM (theme CSS can't reach it)
  var OPTIONS_HEADING_TEXT = 'How would you like to buy it?';

  function ptext(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    c.querySelectorAll('.visually-hidden').forEach(function(n){ n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function parseMoney(str) {
    if (!str) return null;
    var m = str.replace(/,/g, '').match(/([^\d.,]*)([\d]+(?:\.\d+)?)\s*(.*)$/);
    if (!m) return null;
    return { pre: m[1].trim(), num: parseFloat(m[2]), suf: m[3].trim() };
  }
  function fmtMoney(b, n) {
    var p = n.toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (b.pre || '') + p.join('.') + (b.suf ? (' ' + b.suf) : '');
  }
  function getQty() {
    var q = document.querySelector('.product__quantity-input, input[name=quantity]');
    var v = q ? parseInt(q.value, 10) : 1;
    return (isNaN(v) || v < 1) ? 1 : v;
  }
  function selectedOption() {
    if (!sr) return { opt: 'onetime', priceStr: '' };
    var checked = sr.querySelector('input[name=purchaseOption]:checked');
    var opt = checked ? checked.value : 'onetime';
    var card = sr.querySelector('.rc-purchase-option__selected') || (checked && checked.closest('.rc-purchase-option'));
    var priceEl = card && (card.querySelector('[part~="rc-purchase-option__discounted-price"]') || card.querySelector('[part~="rc-purchase-option__price"]'));
    return { opt: opt, priceStr: ptext(priceEl) };
  }
  // Inject "<div class='product-options-heading'>" inside the widget, only when a
  // subscription option is present. Runs inside shadow DOM, so it carries its own <style>.
  function syncOptionsHeading() {
    if (!sr) return;
    var root = sr.querySelector('.rc-widget__root');
    if (!root) return;
    var hasSubscription = !!sr.querySelector('.rc-purchase-option__subscription, input[value="subscription"]');
    var existing = sr.querySelector('.product-options-heading');

    if (hasSubscription && !existing) {
      if (!sr.querySelector('style[data-gf-options-heading]')) {
        var style = document.createElement('style');
        style.setAttribute('data-gf-options-heading', '');
        style.textContent = '.product-options-heading{font-size:12px;font-weight:600;color:#3A3A3A;margin:0 0 10px;}';
        root.prepend(style);
      }
      var heading = document.createElement('div');
      heading.className = 'product-options-heading';
      heading.textContent = OPTIONS_HEADING_TEXT;
      var group = sr.querySelector('.rc-purchase-option-group');
      if (group) { group.parentNode.insertBefore(heading, group); }
      else { root.prepend(heading); }
    } else if (!hasSubscription && existing) {
      existing.remove();
    }
  }

  function update() {
    if (!$summary.length && !$sticky.length) return;
    var qty = getQty();
    var vinput = document.querySelector('.product-variants .variant_list input:checked') || document.querySelector('.product-variants .variant_list input');
    var fallbackTitle = $summary.attr('data-product-title') || $sticky.attr('data-product-title') || '';
    var fallbackPrice = $summary.attr('data-product-price') || $sticky.attr('data-product-price') || '';
    // variative product → selected variant title; otherwise → product title
    var title = vinput ? vinput.getAttribute('data-title') : fallbackTitle;
    var o = selectedOption();
    // price: widget → selected variant → product price
    var priceStr = o.priceStr || (vinput ? vinput.getAttribute('data-price') : '') || fallbackPrice;
    var money = parseMoney(priceStr);

    // Option label only when the subscription widget is present
    var desc = qty + ' x ' + title;
    if (hasWidget) {
      var optLabel = o.opt === 'subscription' ? 'Subscribe & save' : 'One-time purchase';
      desc += ' · ' + optLabel;
    }

    if ($summary.length) {
      $summary.find('[data-summary-desc]').text(desc);
      $summary.find('[data-summary-total]').text((qty === 1 || !money) ? priceStr : fmtMoney(money, money.num * qty));
    }
    if ($sticky.length) {
      $sticky.find('[data-sticky-desc]').text(desc);
      $sticky.find('[data-sticky-price]').html(priceStr);
    }
  }

  // ReCharge hydrates the shadow DOM asynchronously — wait for it before observing.
  var observing = false;
  function attachObserver() {
    if (observing) return true;
    var w = document.querySelector('recharge-subscription-widget');
    sr = w && w.shadowRoot;
    if (!sr) return false;
    new MutationObserver(function(){ setTimeout(function(){ syncOptionsHeading(); update(); }, 50); })
      .observe(sr, { subtree: true, attributes: true, childList: true, attributeFilter: ['class', 'part'] });
    observing = true;
    syncOptionsHeading();
    update();
    return true;
  }

  if (hasWidget && !attachObserver()) {
    var tries = 0;
    var iv = setInterval(function(){ if (attachObserver() || ++tries > 40) clearInterval(iv); }, 200);
  }

  $(document).on('change click', '.product-variants .variant_list input', function(){ setTimeout(update, 50); });
  $(document).on('input change', '.product__quantity-input, input[name=quantity]', update);
  $(document).on('click', '.quantity-selector__wrapper button, [class*=quantity] button', function(){ setTimeout(update, 50); });

  // Sticky ATC (mobile only via CSS): show it while the main Add-to-cart is out of view.
  if ($sticky.length) {
    var mainAtc = document.querySelector('.product__section--main button[name="add"]');
    var stickyEl = $sticky[0];
    // The product <section> has a transform, which would make position:fixed relative to it.
    // Move the bar to <body> so it stays pinned to the viewport.
    document.body.appendChild(stickyEl);
    if (mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){
        stickyEl.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(mainAtc);
    }
    // sticky button proxies the real Add-to-cart
    $sticky.on('click', '[data-sticky-add]', function(e){ e.preventDefault(); if (mainAtc) mainAtc.click(); });

    // mirror the main button's label (Add to cart / Adding / Added) onto the sticky button
    var stickyBtn = stickyEl.querySelector('[data-sticky-add]');
    var mainText = mainAtc && mainAtc.querySelector('[data-add-to-cart-text]');
    if (stickyBtn && mainText) {
      var mirrorLabel = function(){
        stickyBtn.textContent = mainText.textContent.trim();
        stickyBtn.classList.toggle('disabled', mainAtc.classList.contains('disabled'));
      };
      new MutationObserver(mirrorLabel).observe(mainText, { childList: true, characterData: true, subtree: true });
      new MutationObserver(mirrorLabel).observe(mainAtc, { attributes: true, attributeFilter: ['class'] });
      mirrorLabel();
    }
  }

  update();
});
